import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PayoutDetailsModalProps} from '@Modals/payout-details-modal/payout-details-modal.types';

export const openPayoutDetailsModal = (props: PayoutDetailsModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.PAYOUT_DETAILS_MODAL,
      panelProps: props,
    })
  );
};
